<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Preface-rw auto-rw page-open-left-rw" epub:type="frontmatter preface" id="preface001">
<h1 class="preface-title"><a id="page-i"></a><span href="#/toc#toc-preface001" title="Link target outside of Sample">About <em>Saints and Sinners</em></span></h1>
<p class="noindent">With language that is always bold and vital, Edna O’Brien pays tribute to the universal forces that rule our lives. In the
         story “Send My Roots Rain,” Miss Gilhooley, a librarian, waits in the lobby of a posh Dublin hotel, expecting to meet a celebrated
         poet and occasional correspondent while reflecting on the great love who disappointed her. The Irish workers of “Shovel Kings”
         have dreams of becoming millionaires in London but long for their quickly changing homeland—exiles in both places. “Green
         Georgette” is a searing dissection of class, through the eyes of a little girl; “Black Flower” takes on the Troubles by way
         of the tentative relationship between a former prisoner and his sponsor. “Old Wounds” illuminates the importance of family
         and memory in old age.
      </p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface001.vue?187050a5